export default __webpack_public_path__ + "static/media/151-plans.c6e1c2b7.png";